MultiSelectFilter.$inject = ['$filter'];
export function MultiSelectFilter($filter) {
    var filter =  function (list, arrayFilter, fieldPath) {
        if (!arrayFilter || arrayFilter.length === 0) {
            return list;
        }
        return $filter('filter')(list, function (item) {
            return arrayFilter.indexOf(_getField(item, fieldPath)) != -1;
        });
    };
    return filter;
}

function _getField(obj, fieldPath) {
    var arr = fieldPath.split(".");
    while (arr.length && (obj = obj[arr.shift()])) {}
    return obj;
}